import SignInPage from './SignInPage';
import SignUpPage from './SignUpPage';
import UserPage from './UserPage';

export default UserPage;
export { SignInPage, SignUpPage };
